import * as React from 'react';
import { Button } from 'reactstrap';
import Confirm from '../Confirm';

interface EditResetButtonState {
	isConfirmOpen: boolean;
}

interface EditResetButtonProps {
	disabled: boolean;
	initialValues: any;
	reset(initialValues: any): void;
	className?: string;
}

class EditResetButton extends React.Component<EditResetButtonProps, EditResetButtonState> {
	constructor(props) {
		super(props);

		this.state = {
			isConfirmOpen: false,
		};
	}

	private resetForm = () => {
		this.props.reset(this.props.initialValues);
		this.toggleResetConfirm();
	};

	private toggleResetConfirm = () => {
		this.setState({ isConfirmOpen: !this.state.isConfirmOpen });
	};

	public render() {
		return (
			<>
				<Button
					className={this.props.className}
					type="button"
					color="primary-alt"
					outline
					onClick={this.toggleResetConfirm}
					disabled={this.props.disabled}
				>
					Reset
				</Button>

				<Confirm
					isOpen={this.state.isConfirmOpen}
					onConfirm={this.resetForm}
					onCancel={this.toggleResetConfirm}
					renderTitle={() => 'Warning'}
					renderContents={() => 'Are you sure you want to reset this form? Your changes will be lost.'}
					confirmButtonText="Reset Form"
				/>
			</>
		);
	}
}

export default EditResetButton;
